import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectStatusFilter = createSelector(
  [(store: RootState) => store.documentsSignerList.statusFilter],
  (value) => value
);
